module.exports = __webpack_public_path__ + "img/nr.01177691.svg";